import { memo } from 'react';
import LoadingOverlay from 'react-loading-overlay-ts';
import { useTheme } from '@mui/material';

import { Loader } from './Loader';

interface Props {
  children: React.ReactNode;
  loading: boolean;
  showContent?: boolean;
  styles?: Record<string, unknown>;
}

export const LoadingContainer = memo(({ children, loading, showContent, styles }: Props) => {
  const theme = useTheme();

  return (
    <LoadingOverlay
      active={loading}
      spinner={<Loader />}
      styles={{
        wrapper: (base) => ({
          ...base,
          position: 'relative',
          overflow: 'visible',
          zIndex: 'auto',
        }),
        overlay: (base) => ({
          ...base,
          background: 'rgba(255, 255, 255, 0.5)',
          backdropFilter: 'blur(1px)',
          position: 'absolute',
          zIndex: theme.zIndex.modal,
          pointerEvents: loading ? 'auto' : 'none',
          ...styles,
        }),
      }}>
      {loading ? (showContent ? children : null) : children}
    </LoadingOverlay>
  );
});
